const initialState = {
    user_loading:false,
    common_loader:false,
    store_loader:false,
    vendor_loader:false
  };

const uiReducer = (state = initialState,action)=>{
    switch(action.type){
        case 'USER_LOADING':
            return {...state,user_loading:true}
        case 'USER_UNLOADING':
            return {...state,user_loading:false}
        case 'COMMON_LOADING':
                return {...state,common_loader:true}
        case 'COMMON_UNLOADING':
                return {...state,common_loader:false}
        case 'STORE_LOADING':
                    return {...state,store_loader:true}
        case 'STORE_UNLOADING':
                    return {...state,store_loader:false}
        case 'VENDOR_LOADING':
                    return{...state,vendor_loader:true}
        case 'VENDOR_UNLOADING':
                    return{...state,vendor_loader:false}
        default:
            return state
    }
}

export default uiReducer